import { gsap } from 'gsap';

const burger = document.querySelector('.mksun-layout-header__ctn__burger');
const burgerSpan = burger.querySelector('span');
const menu = document.querySelector('.mksun-layout-header__ctn__menu');
let open = false;

burger.addEventListener('click', () => {
    open = !open;
    if(open) {
        burgerSpan.classList.toggle('open');
        gsap.to(menu, { translateX: 0, duration: 0.3, ease: "power1.out" });
        //gsap.set(burgerSpan, { "--color-burger": "var(--neutral-50)" });
    } else {
        burgerSpan.classList.toggle('open');
        gsap.to(menu, { translateX: '100%', duration: 0.3, ease: "power1.in" });
        //gsap.set(burgerSpan, { "--color-burger": "var(--neutral-950)" });
    }
});

// listen to resize
window.addEventListener('resize', () => {
    if(window.innerWidth > 1024) {
        gsap.set(menu, { translateX: 0 });
    } else {
        if(open) {
            burgerSpan.classList.add('open');
            gsap.to(menu, { translateX: 0, duration: 0.3, ease: "power1.out" });
            //gsap.set(burgerSpan, { "--color-burger": "var(--neutral-50)" });
        } else {
            burgerSpan.classList.remove('open');
            gsap.to(menu, { translateX: '100%', duration: 0.3, ease: "power1.in" });
            //gsap.set(burgerSpan, { "--color-burger": "var(--neutral-950)" });
        }
    }
});

